module.exports = __webpack_public_path__ + "static/media/WhiteCollarBlue-Company-Newsletter.d54a67c0.pdf";